// extracted by mini-css-extract-plugin
module.exports = {"button":"SendButton_button_3PvwH","background":"SendButton_background_3YNXn"};